import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '~/components/atoms/button/button';
import ChevronIcon from '~/components/atoms/icon/chevron/ChevronIcon';
import styles from './showMoreButton.module.scss';

interface FilterShowMoreButtonProps {
    showMoreCount: number;
    onClickHandler: () => void;
    showAllValues: boolean;
}

const ShowMoreButton: React.FC<
    FilterShowMoreButtonProps & React.HTMLAttributes<HTMLButtonElement> & { 'data-testid'?: string }
> = ({ showMoreCount, showAllValues, onClickHandler, ...buttonAttributes }) => {
    return (
        <div className={styles.showMore}>
            <Button
                onclick={onClickHandler}
                className={styles.showMore}
                link={true}
                small={true}
                block={true}
                {...buttonAttributes}
            >
                <span>
                    {showAllValues ? (
                        <FormattedMessage id="hide_more" defaultMessage="Skrýt dalších" />
                    ) : (
                        <FormattedMessage id="show_more" defaultMessage="Zobrazit dalších" />
                    )}{' '}
                    {showMoreCount}
                </span>
                <span style={{ paddingLeft: '5px' }}>
                    <ChevronIcon direction={showAllValues ? 'up' : 'down'} width={6} />
                </span>
            </Button>
        </div>
    );
};

export default ShowMoreButton;
